import {EDIT_EXTRA_EVENT} from "../../../constants/ExtraConstants";
import {EventStoredObject, MarketCapObject, MoneyLineObject} from "../../../@types/response";
import {GeneralAction} from "../../../@types/actions";

export const UpdateEventAction = (event: EventStoredObject, marketsCap: MarketCapObject, moneyLines: MoneyLineObject): GeneralAction<any> => ({
    type: EDIT_EXTRA_EVENT,
    payload: {event, marketsCap, moneyLines}
});
